import * as defaultImport from "@splunk/dashboard-event-handlers";
export * from "@splunk/dashboard-event-handlers";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
